'use client';
import type { ReactNode } from 'react';
import React, { useRef, useState } from 'react';
import DraggableWrapper from '../common/DraggableWrapper';

/**
 * AntD Modal Drag Component
 * Usage:
 * <Modal modalRender={modal => <ModalDragger modal={modal} />}
   />
 */
export const ModalDragger = ({
  modal,
  notDraggableTags = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'],
  notDraggableParentClasses = [
    '.ant-select',
    '.ant-btn',
    '.ant-dropdown',
    '.cm-editor',
    '.ant-select-dropdown',
    '.ant-modal-close',
    '.ant-popover',
  ],
}: {
  modal: ReactNode;
  notDraggableTags?: string[];
  notDraggableParentClasses?: string[];
}) => {
  const draggleRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // if boundsRef is not provided, DraggableWrapper will calculate bounds based on window size
  // if positionType is "relative", DraggableWrapper will calculate bounds based on transform
  return (
    <DraggableWrapper
      innerRef={draggleRef}
      position={position}
      disabledTags={notDraggableTags}
      disabledParentClasses={notDraggableParentClasses}
      onDragEnd={setPosition}
      positionType="relative"
    >
      {modal}
    </DraggableWrapper>
  );
};
